export default {
  meau: {
    nav1: 'メイン',
    nav2: 'コミュニティ',
    nav3: 'クライアントのダウンロード',
    nav4: 'ノード報酬',
    nav5: 'NFT'
  },
  cont1: {
    text1: 'ブロックチェーン技術に基づいた遠隔制御ソフトウェア',
    text2: 'マルチスクリーンインターコネクトで、いつでもどこでもできる仕事と娯楽',
    btn: '無料ダウンロード',
    text3_1: '加入',
    text3_2: 'コミュニティ',
    text3_3: 'DeepLink Coin取得'
  },
  cont2: {
    text1: 'DeepLink',
    text2: 'eスポーツレベルの低遅延技術能力により、すべてのデバイスを簡単に入手可能',
    text3: 'コアコンピテンシーと技術の優位性',
    text4: 'クラウドゲームのコアコンピテンシーに基づき、従来のリモートコントロールをはるかに上回る体験を提供！',
    leaf1: {
      text1: '高流暢、高性能',
      text2: '低コスト',
      text3: '業界一流のコーデックソリューション、同コードレートの性能消耗とリソース占用率最低。',
      text4: 'peer-to-peer:  IPv6をサポートし、最大95%のNATスルーレート、帯域幅占用率ゼロ。'
    },
    leaf2: {
      text1: '高フレームレート、低遅延',
      text2: '',
      text3: 'LAN遅延<15ms、且つ4Kの画質と240Hzのリフレッシュレード、WAN評価も世界トップクラス。'
    },
    leaf3: {
      text1: '高鮮明',
      text2: '',
      text3: 'インテリジェントアルゴリズムにより、同コードレートでの可視性が向上し、最もリアルなカラー表現が復元されます。'
    },
    leaf4: {
      text1: '高安定性',
      text2: '',
      text3: '大量のデータサポートによるパケット損失及び抗渋滞対策で、パケット損失および渋滞に対し迅速な調整が可能。'
    },
    leaf5: {
      text1: '高安全性',
      text2: '',
      text3: 'すべてのデータはAES256のDTLS1.2通して暗号化される 。'
    }
  },
  cont3: {
    text1: '優れた流暢性、まるでローカルデバイスを操作しているようです',
    text2: 'DeepLinkは、3つの分野、数十項目の最適化技術を適用して、パケット損失率5%、ネットワーク遅延100msが発生しても、高いフレームレートでスムーズに動作するので、さまざまなネットワーク環境に対応しています。',
    li1: {
      text1: '弱電波対抗技術',
      text2: 'FECパケット損失防止策略',
      text3: '帯域幅予測',
      text4: 'SVCエンコード策略'
    },
    li2: {
      text1: '伝送最適化技術',
      text2: 'ポート指紋予測',
      text3: 'IPV6サポート',
      text4: 'UPNP',
      text5: 'インテリジェントルート選択'
    },
    li3: {
      text1: '処理技術の表示',
      text2: 'フレームレート自行適応ポリシー',
      text3: '動的画面の予測',
      text4: 'Jitter処理策略',
      text5: 'AI低コードレートのHDレンダリング',
      text6: 'ダイナミックバーチャルリアリティ'
    },
    desc3: 'LAN<5ms·都市間ネットワーク<10ms·地域間ネットワーク<30ms'
  },
  cont4: {
    text1: '超高精細グラフィックス画質',
    text2: '極精細解像度',
    text3: '10.7亿カラーサポート',
    text4: '4:4:4 無損失画質',
    text5: 'DeepLinkは生まれてから行内で一番厳しい基準の画質指標を採用して伝統的のリモートテクノロジを遥かに上回る画質の体験を実現しています。リモート画像の歪みは人間の視力が認識できる限界値を下回るため、精純度要請が高いクリエイティブ業界要求にサポート致します。',
    text6: '*PSNRとはピーク信号対雑音比で、20dB未満では画面歪みが高く、20~30dBでは画面歪みが普通で、30~40dBでは画面歪みが低く、40dB以上では画面歪みが極める低く人間の視力では認識できないです。'
  },
  cont5: {
    text1: '豊富な周辺機器サポート',
    text2: 'DeepLinkは、クリエイティブ業界にタブレット、ハンドルなどのプロフェッショナル周辺機器のリモートサポートを提供し、PS、Zbrush、Unityなどのクリエイティブソフトウェアの使用を最適化することで、リモート状態とローカル状態でのクリエイティブな生産ツール体験の一貫性を確保します。。'
  },
  cont6: {
    text1: '多重保証・極簡単な操作',
    block1: {
      title1: 'アカウントの安全',
      desc1: '多重アカウント保護体制、安心して使用できる',
      title2: '接続セキュリティ',
      desc2: 'DTLS1.2プロトコル保護、認証によるアクセス',
      title3: 'データセキュリティ',
      desc3: '256ビットAES暗号化トランスポート全プロセス秘密保持',
      title4: 'デバイスセキュリティ',
      desc4: 'ユーザーの設定により、許可済みのユーザーのみ、該当のデバイスのみ表示する'
    },
    block2: {
      title1: '多重安全保証',
      desc1: '接続ごとに護衛する',
      title2: '操作が簡単',
      desc2: '簡単に起動する',
    },
    block3: {
      title1: '軽量なダウンロード',
      desc1: 'DeepLinkクライアントは約10M',
      title2: '簡単に手に入る',
      desc2: 'ガイドラインに従ってプロセスを完了できる',
      title3: '使いやすさ',
      desc3: '許可もらったいる任意のデバイスをマウスで遠隔制御可能'
    }
  },
  cont7: {
    text1: 'リモートコントロールソリューションの提供に注力',
    block1: {
      word1: '教育業界',
      word2: 'ゲーム業界',
      word3: 'クリエイティブ·デザイン業界',
      word4: '情報技術業界',
      word5: '出張中の業務人員',
      word6: '各地に散らばった協力者',
      word7: 'ITリモートメンテナンス',
      word8: '個人ユーザとゲーマー'
    },
    block2: {
      text1: '様々な業界のリモートコントロールシーンのサポート',
      text2: '各業界の需要に基づいて、企業の省エネと効率的なビジネス目標の達成をサポートする。',
      text3: 'カスタマイズと暗号化策略、霊活で安全',
      text4: '従業員はいつでもどこでも実際の権限に基づいて企業リソースにアクセスできる。'
    },
    block3: {
      text1: '複数のユーザー需要の上書き',
      text2: '社内従業員に使用させるか，',
      text3: '外部のお客様、パートナー様、もしくは個人様にしようさせる。',
      text4: '我々の遠隔制御技術は、主流なプラットフォームやデバイスを通してサポートできる，',
      text5: '簡単で賢明な解決策を提供する。'
    }
  },
  footer: {
    link: 'リンク',
    community: 'コミュニティ',
    tip: '説明：コミュニティにはTwitter、telegram、reddit、medium、discord、tiktok、YouTube等が含む'
  },
  reward: {
    title1: 'DeepLinkノード',
    desc1: 'インセンティブを取得するチャンスーがある、例えば：DeepLink Token,クラウンNFT、コミュニティ管理の権限。',
    title2: '創世ノードNFTの取得',
    text1: 'DeepLinkのユーザーが多いほど、コンピューティングとトラフィックが必要になります。創世ノードはDeepLinkネットワークのインフラストラクチャを提供することで、DeepLinkの急速な成長を支援する。',
    text2: '創世ノードNFTを購入することで、ネットワークへの貢献によってインセンティブを受けることができる。',
    text3: 'DeepLinkToken、クラウンNFT、コミュニティ管理権限も含まれる。',
    text4_1: 'ご質問がありますか？ ',
    text4_2: 'と',
    text4_3: '上で我々とコミュニケーションを取る。',
    btntext: 'すぐ購入',
    text5: '1000個の創世ノードNFTを販売するごとに、価格は1000USD増値される',
    text6_1: '現時点の毎NFT',
    text6_2: 'サポートノード数',
    text7: '創世ノードNFT総数',
    text8: '永久に増発しない',
    text9: '初期価格',
    text10_1: '每NFTサポートする',
    text10_2: 'ノード最大数',
    text11: '最高価格',
    text12: '創世ノードとは？',
    text13: '創世ノードはDeepLinkのネットワークコンピューティングとトラフィック転送の中核的な役割を担っており、DeepLinkは採掘モデルにより、より多くの人が参加して収益をもらえるようにする。',
    text14: 'どれだけ多くのTokenが創世ノード報酬を与えるか？',
    text15: '総コインの30%，300亿枚DeepLink Token',
    text16: '創世ノードNFTとは',
    text17: '創世ノードNFTを持ってこそ、採掘に参加することができる。',
    text18: '創世ノードNFT販売の収入はどのように分配するか？',
    text19: '収益の50%は脱中心化流動性ボーナスプール(例えば：Uniswap,SushiswapのDeepLink Token/USDC)に投入され、50%はDeepLink運用会社の収益です。',
    text20: '具体的な採掘メカニズムは何ですか?',
    text21: '１年に計50億の賞与、3年に半減、DeepLink クラウンNFT収益の10%がDeepLink Tokenを買い戻し、毎回半減になる前に総ボーナスプールに追加し、総ボーナス50%Tokenとして3年に分けてすべてのノードにボーナスを支給します。例えば、3年後、DeepLinkクラウンNFT収益の10%がDeepLinkTokenを120億枚買い戻すと、ボーナスプールの残余総数は120億+150億枚となり、二回目の３年からは毎年270億*50%*1/3=45億枚となります',
    text22: '創世ノード機器の要求事項は？',
    text23: '機器は既にDeepBrainChainのネットワーク内に存在しなければならず，DeepBrainChainは脱中心化された高性能計算ネットワークであり，DeepBrain Chain中の機器は既にDBCを質入れしており，機器の安定性を保証している.DeepBrain Chainの詳細について：',
    text24: '創世ノードNFTを持っていると他になにか利点があるか？',
    details: {
      text1: '1.一定数の創世ノードNFTを保有することにより、一国のDeepLinkNFT販売総代理権を獲得することができる(国の人口比率によって300万人当たり1つのNFTが必要)；',
      text2: '2.DeepLink Coin airdrop；',
      text3: '3.DeepLinkインキュベーションゲームアイテムトークン空投；',
      text4: '4.投票オンラインゲーム権限；',
      text5: '5.ゲームNFT購入割引；',
      text6: '6.クラウドゲームの著作権と期間購入割引；',
      text7: '7.その他のコミュニティ管理参加権限。'
    }
  },
  nft: {
    cont: {
      title1: 'クラウンNFT',
      desc1: 'このNFTを持つことで，DeepLinkソフトウェアのすべての機能に対して1年間の使用権限がある。',
      desc2: 'NFTは購入後休眠状態であり、このNFTを使用する場合はDeepLinkソフトウェアで活性化し、NFTが活性化すると',
      desc3: '1年の使用期間がカウントダウンを開始し、DeepLinkソフトウェアNFT収益の10%をノードボーナスとして投入される，',
      desc4: '収益の40%がストリーミングボーナスプールに投入され、50%eeDeepLink産業の収益。',
      desc1_1: 'このNFTを持つことで，DeepLinkソフトウェアのすべての機能に対して1年間の使用権限がある。',
      desc2_1: 'NFTは購入後休眠状態であり、このNFTを使用する場合、DeepLinkソフトウェアで活性化し、NFTが活性化するとカウントダウンを開始し、1年間の使用期限を設定します。',
      desc3_1: 'DeepLinkソフトウェアNFTの収益の10%はノードボーナスに投入され、収益の40%は流動性ボーナスプール投入し、50%はDeepLink運用会社の収益です。'
    },
    enabl: {
      title1: 'NFT赋能',
      desc1: 'DeepLinkソフトウェアの全機能に1年間の使用権限がある',
      desc2: 'DeepLink Coin airdrop',
      desc3: 'DeepLinkインキュベーションゲームアイテムトークン空投',
      desc4: '投票オンラインゲーム権限',
      desc5: 'ゲームNFT購入割引',
      desc6: 'クラウドゲームの著作権と期間購入割引',
      desc7: 'その他のコミュニティ管理参加権限'
    },
    edition: {
      title1: '専門家版',
      title2: '企業版',
      tip: 'クラウンNFT',
      btn: 'すぐ購入',
      title3: '専門家版 VS 企業版',
      desc: '具体的な機能使用権限',
      list: {
        li1_1: '内容',
        li1_2: '基礎版',
        li1_3: '専門家版',
        li1_4: '企業版',
        li2_1: '最優画質',
        li3_1: '転送中継機室',
        li3_2: '少量',
        li3_3: '大量',
        li4_1: '転送帯域幅',
        li4_2: '最大4M',
        li4_3: '最大20M',
        li4_4: '制限なし',
        li5_1: 'ポートToポート遅延',
        li5_2: '最低<40ms',
        li5_3: '最低<20ms',
        li6_1:'チャンネル数',
        li7_1:'デバイス数',
        li8_1:'遠隔デスクトップ',
        li9_1:'遠隔カメラ',
        li10_1:'遠隔SSH',
        li11_1:'プライバシースクリーン',
        li12_1:'仮想モニタ',
        li13_1:'ゲームキー・マウス',
        li14_1:'多重直流',
        li15_1:'444真彩',
        li16_1:'画面録画・スクリーンショット',
        li17_1:'デュアルスクリーン対デュアルスクリーン',
        li18_1:'ハンドル、タブレット',
        li19_1:'ユーザ/デバイスグループ管理',
        li20_1:'SSOシングルサインオン',
        li21_1:'統合管理権限',
        li22_1:'一括配置',
        li23_1:'従業員行動監査',
        li24_1:'透かし',
        li25_1:'価格'
      }
    }
  }
}